import Link from "next/link";
import { useState } from "react";
import { useMe } from "../../../hooks/useMe";
import { VerificationStatus, verify } from "@jconradi/tutu-porn-api-client/src/me";
import { IconContainer } from "../../Buttons/IconContainer";
import { UnderlinedButton } from "../../Buttons/UnderlinedButton";
import { Spinner } from "../../Spinner/Spinner";
import { SubmitVerification } from "./SubmitVerification";
import { VerificationStatusAlert } from "./VerificationStatusAlert";

export const Verification = () => {
    const meQuery = useMe();

    if (meQuery.isLoading) {
        return <Spinner className="mx-auto" />
    }

    const verification = meQuery.data?.data.verification.verificationStatus;

    return (
        <section className='w-full flex flex-col gap-y-8'>
            {verification === VerificationStatus.None &&
                <SubmitVerification />
            }
            {verification !== VerificationStatus.None &&
                <VerificationStatusAlert verificationStatus={verification} />
            }
        </section>

    )
}